let velocity;

if (typeof window !== 'undefined') {
	velocity = require('velocity-animate');
}
else {
	// mocked velocity library
	velocity = function() {
		return true;
	};
}

export default velocity;


// WEBPACK FOOTER //
// ./helpers/Velocity.js